import App from './App.vue';
import router from './router';
import store from '@/store/store';
import Chartkick from 'vue-chartkick'
import Chart from 'chart.js'

import '@/components';
import { createBootstrap } from 'bootstrap-vue-next'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue-next/dist/bootstrap-vue-next.css'
import 'vuetify/dist/vuetify.min.css';
import TextareaAutosize from 'vue-textarea-autosize';
import VueScrollactive from 'vue-scrollactive';
import ConstPlugin from '@/plugins/ConstPlugin.js'
// import loading from 'vuejs-loading-screen';
import VueChartkick from 'vue-chartkick'
import 'chartkick/chart.js'
import { createApp } from 'vue'

import 'vuetify/styles'
import { createVuetify } from 'vuetify'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'

import VueDatePicker from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css';
import Vidle from 'v-idle-3'
// import { utilityService } from '@/services/utilityService.js';

const app = createApp(App)

// utilityService.validateResolvedApiBaseUrls();

// if (process.env.NODE_ENV !== 'production') {
//   utilityService.logResolvedApiBaseUrls();
// }

const vuetify = createVuetify({
  components,
  directives,
})


app.component('VueDatePicker', VueDatePicker);
app.use(Vidle);
app.use(VueChartkick)
app.use(TextareaAutosize);
// app.use(TextareaAutosize);
app.use(VueScrollactive);
app.use(store)
app.use(router)
app.use(vuetify)
app.use(createBootstrap())
app.mount('#app')





// import { questionBase } from '@/components/questions/QuestionBase';

// Vue.config.productionTip = false;

// const eventsHub = new Vue();

// Vue.use(IdleVue, {
//   eventEmitter: eventsHub,
//   store,
//   idleTime: 900000, // 900 seconds = 15 minutes
//   startAtIdle: false
// });

// Vue.mixin(questionBase);
// Vue.use(Vuetify);
// Vue.use(BootstrapVue);
// Vue.use(TextareaAutosize);
// Vue.use(VueScrollactive);
// Vue.use(ConstPlugin);
// Vue.use(Chartkick.use(Chart))
// Vue.use(loading, {
//     bg: 'rgba(21, 102, 124, 0.3);',
//     icon: 'v-icon notranslate mdi mdi-loading theme--light',
//     size: 5,
//     icon_color: 'white'
// });

// new Vue({
// 	icons: {
// 		iconfont: 'mdi' // default - only for display purposes
// 	},
// 	router,
// 	store,
// 	vuetify: new Vuetify(),
// 	render: h => h(App)
// }).$mount('#app');
